 <template>
  <div>

    <InManualSw :jobType="'predict'"></InManualSw>

    <b-row>
      <!-- ################## Input ##################-->

      <b-col>
        <b-card border-variant="info" header="入力データ《予測》" class="text-center">
            <!-- Input Pen-->
            <InModalPen v-if="cameraPredict=='pen'" :jobType="'predict'"></InModalPen>
            <!-- Input Pen-->
            <InModalPc v-if="cameraPredict=='pc'" :jobType="'predict'"></InModalPc>
            <!-- Input Pen-->
            <InModalKit v-if="cameraPredict=='kit'" :jobType="'predict'"></InModalKit>
            <div class="rarrow"><img src="../assets/rightarrow.png" alt="RightAllow"></div>
        </b-card>
      </b-col>

      <!-- ################## Result OutPut ##################-->
      <b-col>
        <OutPredict ref="outpredict" @lastPred="lastPredictJob"></OutPredict>
      </b-col>
    </b-row>

    <br/><br/>
    <div>
      <div class="inlineblkcls relativecls">
        <b-button variant="outline-primary" class="long_button" @click="doPredict" :disabled="predBtnDisbl">予測</b-button>
        <div class="alwayschkCls">
          <b-form-checkbox id="alwayschk" v-model="l_alwaysPredict" size="sm" switch switch-variant="outline-primary">
            <b>常時{{alwaysWord}}</b>
          </b-form-checkbox>
        </div>
      </div>
    </div><br/>
    <strong><div id="dispmes2" class="dispmes">{{dispMessage}}</div><div id="consoleev2" class="dispmes"></div></strong>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import InManualSw from '@/components/InManualSw.vue'
import InModalKit from '@/components/InModalKit.vue'
import InModalPc from '@/components/InModalPc.vue'
import InModalPen from '@/components/InModalPen.vue'
import OutPredict from '@/components/OutPredict.vue'
import * as tf from '@tensorflow/tfjs'

const width = 28
const height = 28
const channel = 1

window.addEventListener('error', event => {
  console.log('consoleError2')
  document.getElementById('consoleev2').innerHTML = event.message
})
window.addEventListener('warn', event => {
  console.log('consoleWarn2')
  document.getElementById('consoleev2').innerHTML = event.message
})

export default {
  name: 'aipredict',
  data () {
    return {
      predBtnDisbl: false,
      canvasPred: null,
      ctxPred: null,
      alwaysTimer: null
    }
  },
  computed: {
    ...mapState([ 'cameraPredict', 'model', 'controlKits', 'alwaysPredict', 'inputs', 'controlKits', 'dispMessage' ]),
    l_alwaysPredict: {
      get () {
        return this.alwaysPredict
      },
      set (value) {
        // OFF用のタイマーリセット（ONの時も念のためReset）
        clearInterval(this.alwaysTimer)
        this.predBtnDisbl = value
        // ONの時は予測開始
        if (value) {
          this.doPredict()
          // this.dispMessage = '常時、AI判定を実施しています。'
        } else {
          // this.dispMessage = '常時のAI判定を停止しました。'
        }
        this.$store.dispatch('setAlwaysPredict', value)
      }
    },
    alwaysWord () {
      if (this.alwaysPredict) {
        return 'ON'
      } else {
        return 'OFF'
      }
    }
  },
  components: {
    InManualSw,
    InModalKit,
    InModalPc,
    InModalPen,
    OutPredict
  },
  methods: {
    doPredict () {
      if (this.model === undefined || this.model === null) {
        this.closePredict('AI学習が完了していません。最初にAI学習を実施して下さい。')
        return
      }
      // this.$refs.outpredict.updateChartData(false, []) // ラベル再表示しても見えない
      this.predBtnDisbl = true
      this.canvasPred = document.getElementById('draw_canvas28')
      this.ctxPred = this.canvasPred.getContext('2d')
      // 画像オブジェクトを生成
      if (this.canvasPred.toDataURL() === '') {
        this.closePredict('データが設定されていません。')
        return
      }
      this.doPredictCommit()
    },
    async doPredictCommit () {
      const predImgNum = 1
      const datasetBytesBuffer = new ArrayBuffer(predImgNum * (width * height) * 4) // 仮保存用配列バッファ
      // datasetBytesBufferをFloat32Arrayに置き換えてByte操作する
      // datasetBytesBufferに第二引数の場所に第３引数分のFloat32Arrayを作成
      const datasetBytesView = new Float32Array(datasetBytesBuffer, 0, ((width * height) * predImgNum))
      // ----------------- 画像をArrayBuffer配列で作成 ----------------
      const imageData = this.ctxPred.getImageData(0, 0, width, height)
      // 画像データを保存する（グレースケールで処理、RGBは同じ値なのでRedのみ保存：TensorFlowのdata.jsを踏襲）
      for (let j = 0; j < imageData.data.length / 4; j++) {
        if (this.cameraPredict === 'pen') {
          datasetBytesView[j] = (255 - imageData.data[(j * 4) + 3]) / 255
          // datasetBytesView[(i * width * height) + j] = (255 - imageData.data[(j * 4) + 3]) / 255
        } else {
          var grayscale = parseInt((imageData.data[(j * 4)] + imageData.data[(j * 4) + 1] + imageData.data[(j * 4) + 2]) / 3, 10)
          datasetBytesView[j] = grayscale / 255
          // datasetBytesView[(i * width * height) + j] = grayscale / 255
        }
      }
      // 画像のFloat32Array配列データ作成
      const allxdata = new Float32Array(datasetBytesView) // Float32:RGBA(4Byte=>32Bit)
      const testxs = tf.tensor2d(allxdata, [predImgNum, (width * height)]).reshape([predImgNum, width, height, channel])
      this.predData = await this.model.predict(testxs) // argmax(-1)：モデル時は各クラス確率を出力
      // this.predData = this.predData[0][0]
      // console.log(JSON.stringify(this.predData, null, '\t'))
      // console.log(this.predData.dataSync())
      this.$refs.outpredict.updateChartData(true, this.predData.dataSync())
      // Kit連携チェック
      if (this.controlKits.renkei) {
        await this.$refs.outpredict.controlKitRenkei()
      } else {
        this.lastPredictJob()
      }
    },
    lastPredictJob () {
      // 連続判定チェック
      if (this.alwaysPredict) {
        this.alwaysTimer = setTimeout(this.doPredictCommit, 200)
      } else {
        this.closePredict('予測が完了しました。')
      }
    },
    closePredict (clsMessage) {
      this.$store.dispatch('setMessage', clsMessage) // メッセージ表示
      this.predBtnDisbl = false // 「予測」ボタンDisable化
      // 直接だと反映されないのでタイマーで時間差で反映させる
      setTimeout(this.alwaysCheckBoxOff, 200)
    },
    alwaysCheckBoxOff () {
      this.$store.dispatch('setAlwaysPredict', false)
      // document.getElementById('alwayschk').checked = false
      // console.log('closePredict')
    },
    loadGraph () {
      this.$refs.outpredict.updateChartData(false, [])
    }
  },
  created () {
  }
}
</script>

<style scoped>
.rarrow {
  position: absolute;
  top: 130px;
  right: -28px;
}
.long_button {
  width: 500px;
  text-align: left;
  padding-left: 170px;
  letter-spacing: 140px;
}
.dispmes {
  font: outline;
  color: red;
}
.card-body {
  padding: 20px 0px;
}
.alwayschkCls {
  display: inline-block;
  position: absolute;
  top: 15px;
  right: -95px;
}
</style>



// WEBPACK FOOTER //
// src/components/AiPredict.vue